import React from 'react';
import { useAuth } from '../contexts/SimpleAuthContext';

function Profile() {
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-purple-900 to-gray-900 py-8">
      <div className="container mx-auto px-4">
        <h1 className="text-3xl font-bold text-white mb-8">Profile</h1>
        
        <div className="bg-gray-800/50 backdrop-blur-sm p-8 rounded-xl border border-purple-500/30">
          {user ? (
            <div>
              <h2 className="text-xl font-semibold text-white mb-4">Account Information</h2>
              <div className="text-gray-300">
                <p><strong>Handle:</strong> {user.handle}</p>
                <p><strong>Display Name:</strong> {user.displayName}</p>
              </div>
            </div>
          ) : (
            <p className="text-gray-400 text-center py-8">Please log in to view your profile.</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default Profile;